export const init = () => {
    const isTrueAgreementValue = (value) => value === '1' || value === true;

    ['datalayer.add_to_cart', 'datalayer.remove_from_cart'].forEach((ev) => {
        window.addEventListener(ev, (e) => {
            const { cart } = e.detail;

            window.SR?.event?.trackCustomEvent(
                'cart.status',
                {
                    cartId: cart.uuid,
                    products: cart.items.map((item) => ({
                        sku: item.purchasable?.id,
                        quantity: item.quantity,
                        brand: 'SAVICKI',
                        category: item.purchasable?.feed_category,
                    })),
                    totalAmount: cart.total_price,
                    totalQuantity: cart.items.length,
                    itemIds: cart.items.map((item) => item.purchasable?.id),
                },
                'CartStatus'
            );
        });
    });

    ['datalayer.clear_cart', 'datalayer.purchase'].forEach((ev) => {
        window.addEventListener(ev, () => {
            window.SR?.event?.trackCustomEvent(
                'cart.status',
                { products: [], totalAmount: 0, totalQuantity: 0 },
                'CartStatus'
            );
        });
    });

    window.addEventListener('datalayer.checkout_customer_data', (e) => {
        const { cart, formData } = e.detail;

        const payload = {
            email: formData.address.payment.email,
            phone: formData.address.payment.phone.replace(/\s+/g, ''),
            firstname: formData.address.payment.firstname,
            lastname: formData.address.payment.lastname,
            city: formData.address.payment.city,
            lead_form_code: 'not_finished_order',
            source_type: 'cart',
            source_id: cart.id,
            source_url: window.location.href,
        };

        if (isTrueAgreementValue(formData.agreement?.sms?.value)) {
            payload.orderStatusAgreementSMS = 'enabled';
        }

        if (isTrueAgreementValue(formData.agreement?.contact?.value)) {
            payload.orderIssuesAgreementContact = 'enabled';
        }

        // const eventType = syneriseEventType || 'lead';
        window.SR?.event?.sendFormData('order_step1', payload);
    });

    window.addEventListener('datalayer.purchase-before', (e) => {
        const { cart, formData } = e.detail;

        const payload = {
            email: formData.address.payment.email,
            phone: formData.address.payment.phone.replace(/\s+/g, ''),
            firstname: formData.address.payment.firstname,
            lastname: formData.address.payment.lastname,
            // lead_form_code: 'finished_order',
            source_type: 'cart',
            source_id: cart.id,
            source_url: window.location.href,
        };

        if (isTrueAgreementValue(formData.agreement?.marketing?.value)) {
            payload.newsletterAgreement = 'enabled';
        }

        if (isTrueAgreementValue(formData.agreement?.tos?.value)) {
            payload.tosAgreement = 'enabled';
        }

        if (isTrueAgreementValue(formData.agreement?.external_opinion?.value)) {
            payload.externalOpinionAgreement = 'enabled';
        }

        window.SR?.event?.sendFormData('order_step2', payload);
    });

    window.addEventListener('datalayer.lead_success', (e) => {
        const { formData, syneriseEventType } = e.detail;

        const payload = {
            lastname: formData.lastname,
            firstname: formData.firstname,
            email: formData.email,
            phone: formData.phone.replace(/\s+/g, ''),
            city: formData.city,
            lead_form_code: formData.lead_form_code,
            source_id: formData.source_id,
            source_type: formData.source_type,
            source_url: formData.source_url,
        };

        // const payload = {

        //     ...formData,
        //     phone: formData.phone.replace(/\s+/g, ''),
        // };

        if (isTrueAgreementValue(formData.agreement?.marketing?.value)) {
            payload.newsletterAgreement = 'enabled';
        }

        const eventType = syneriseEventType || 'lead';

        window.SR?.event?.sendFormData(eventType, payload);
    });

    window.addEventListener('datalayer.order_measure_success', (e) => {
        const { formData } = e.detail;

        const synerisePayload = {
            lastname: formData.lastname,
            firstname: formData.firstname,
            email: formData.email,
            phone: formData.phone.replace(/\s+/g, ''),
            city: formData.city,
            lead_form_code: 'measuring_tool',
            source_id: formData.product_id,
            source_type: 'measuring_tool',
            source_url: window.location.href,
        };

        if (isTrueAgreementValue(formData.agreement?.marketing?.value)) {
            synerisePayload.newsletterAgreement = 'enabled';
        }

        window.SR?.event?.sendFormData('lead_v3_miarka', synerisePayload);
    });

    window.addEventListener('datalayer.auth_login', (e) => {
        const { formData, userData } = e.detail;

        const payload = {
            email: formData.email,
        };

        if (userData.firstname) {
            payload.firstName = userData.firstname;
        }
        if (userData.lastname) {
            payload.lastName = userData.lastname;
        }
        if (userData.phone) {
            payload.phone = userData.phone.replace(/\s+/g, '');
        }

        window.SR?.event?.sendFormData('login', payload);
    });

    window.addEventListener('datalayer.recommendation_view', (e) => {
        const { campaignId, correlationId, items } = e.detail;

        console.log({ campaignId, correlationId, items });

        window.SR.event.trackCustomEvent('recommendation.view', {
            campaignId,
            correlationId,
            items,
        });
    });

    window.addEventListener('datalayer.product_click', (e) => {
        const { product, element } = e.detail;

        const recommendationContainer = element?.closest('.js-vue-synerise-recommendations');

        if (recommendationContainer) {
            const { campaignId } = recommendationContainer.dataset;
            const { correlationId } = recommendationContainer.dataset;

            console.log({ campaignId, correlationId, product });

            window.SR.event.trackCustomEvent('recommendation.click', {
                campaignId,
                correlationId,
                item: String(product.id),
            });
        }
    });

    window.addEventListener('datalayer.auth_register', (e) => {
        const { formData } = e.detail;

        const payload = {
            email: formData.email,
            firstname: formData.firstname,
            lastname: formData.lastname,
            phone: formData.telephone.replace(/\s+/g, ''),
        };

        if (isTrueAgreementValue(formData.agreement?.marketing?.value)) {
            payload.newsletterAgreement = 'enabled';
        }
        if (isTrueAgreementValue(formData.agreement?.tos?.value)) {
            payload.tosAgreement = 'enabled';
        }

        window.SR?.event?.sendFormData('register', payload);
    });
};
